// Dependencies
import React from 'react';
import radium from 'radium';

import history from '../lib/history';

import Button from '../components/button/Button.tsx';
import ButtonEventsOverview from '../components/button-events-overview/ButtonEventsOverview.jsx';
import {ThemeContext} from "../components/theme/Theme.jsx";

function UnknownErrorPage(props) {
	const context = React.useContext(ThemeContext)
	const style = {
		container: {
			margin: 'auto',
		},
		error: {
			fontWeight: '600',
			textAlign: 'center',
		},
		buttonContainer: {
			marginTop: '3em',
		},
	};

	const eventSpecific = !!props.eventUuid;

	function navigateToStartPage() {
		history.push(`${props.eventUuid}`);
	}

	return (
		<div style={style.container}>
			<div style={style.error}>
				Leider ist ein Fehler aufgetreten. < br />
				Bitte versuchen Sie es erneut. < br />
				< br />
				Falls das Problem weiterhin besteht, kontaktieren Sie uns bitte unter 07152 9259 700 oder
				<a href="mailto:support@leoticket.de"> support@leoticket.de</a>.
			</div>
			{eventSpecific &&
				<Button
					name="to_startpage"
					buttonText="Zur Startseite"
					btnStyle="highlight"
					onClick={navigateToStartPage}
					buttonContainerStyle={style.buttonContainer}
				/>
			}
			{!eventSpecific &&
				<ButtonEventsOverview
					btnText={context.themeManager.getThemeTextOrHardcodedDefault('goToEventOverviewBtnLabel')}
					buttonContainerStyle={style.buttonContainer}
					iconName="angle-double-left"
				/>
			}
		</div>
	);
}

export default radium(UnknownErrorPage);
